import type { ReactNode } from "react";
import { WidgetRegistryProvider } from "@salestrak/ui";

import { AppWidgetControls } from "#app/widgets/controls";
// Importing `widgetRegistry` also runs its module side effect: every shipped
// widget is registered onto it (see `widgets/registry.ts`).
import { widgetRegistry } from "#app/widgets/registry";
// The issue-widget defs register from their feature barrel instead of
// `widgets/registry.ts` — they import issue-view components, whose graph the
// registry itself reaches (team-members def), so registering them inside the
// registry module would be a cycle. This import runs after the registry has
// fully evaluated.
import "#app/widgets/issue";

/**
 * The widget-kit provider pair the workspace layout mounts.
 *
 * It stays its own file so the workspace layout never carries the registry's
 * load-time side effects: importing `widgets/registry` registers every shipped
 * widget, and importing `features/issue-widgets` must happen strictly after
 * that module has fully evaluated. Keeping both imports here makes that order
 * explicit instead of implicit in a route file.
 */
export function WidgetProviders({ children }: { children: ReactNode }) {
  return (
    <WidgetRegistryProvider registry={widgetRegistry}>
      <AppWidgetControls>{children}</AppWidgetControls>
    </WidgetRegistryProvider>
  );
}
